import React, { useState } from 'react';
import api from '../../utils/api';
import { T, STATUS, STATUS_ORDER } from '../theme';
import { MultiSelect } from './Bits';

export default function CreateTaskModal({ brands, users, types, fixedAccountId, onClose, onCreated }) {
  const [title, setTitle] = useState('');
  const [accountId, setAccountId] = useState(fixedAccountId ? [fixedAccountId] : []);
  const [typeIds, setTypeIds] = useState([]);
  const [assigneeIds, setAssigneeIds] = useState([]);
  const [dueDate, setDueDate] = useState('');
  const [status, setStatus] = useState('todo');
  const [sprint, setSprint] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!title.trim()) { alert('Görev başlığı zorunlu'); return; }
    setSaving(true);
    try {
      await api.post('/pm/tasks', {
        title: title.trim(),
        account_id: (fixedAccountId || accountId[0]) || null,
        type_ids: typeIds, assignee_ids: assigneeIds,
        due_date: dueDate || null, status, sprint_point: sprint === '' ? 0 : Number(sprint),
      });
      onCreated && onCreated();
      onClose();
    } catch (e) { alert('Oluşturulamadı: ' + (e.response?.data?.error || e.message)); }
    finally { setSaving(false); }
  };

  return (
    <Overlay onClose={onClose}>
      <h3 style={{ color: T.text, margin: '0 0 16px', fontSize: 17 }}>Yeni Görev</h3>
      <Field label="Görev">
        <input autoFocus value={title} onChange={e => setTitle(e.target.value)} placeholder="Görev başlığı"
          style={inp} />
      </Field>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {!fixedAccountId && (
          <Field label="Marka">
            <MultiSelect single options={brands.map(b => ({ id: b.id, label: b.brand_name || b.company_name }))}
              value={accountId} onChange={setAccountId} placeholder="Marka seç" />
          </Field>
        )}
        <Field label="Task Type (çoklu)">
          <MultiSelect options={types.map(t => ({ id: t.id, label: t.name }))} value={typeIds} onChange={setTypeIds} placeholder="Tip seç" />
        </Field>
        <Field label="Assignee (çoklu)">
          <MultiSelect options={users.map(u => ({ id: u.id, label: u.name }))} value={assigneeIds} onChange={setAssigneeIds} placeholder="Kişi seç" />
        </Field>
        <Field label="Due Date">
          <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} style={{ ...inp, colorScheme: 'dark' }} />
        </Field>
        <Field label="Status">
          <select value={status} onChange={e => setStatus(e.target.value)} style={inp}>
            {STATUS_ORDER.map(k => <option key={k} value={k}>{STATUS[k].label}</option>)}
          </select>
        </Field>
        <Field label="Sprint Point">
          <input type="number" min="0" value={sprint} onChange={e => setSprint(e.target.value)} style={inp} />
        </Field>
      </div>
      <div style={{ display: 'flex', gap: 10, marginTop: 20, justifyContent: 'flex-end' }}>
        <button onClick={onClose} style={btnGhost}>İptal</button>
        <button onClick={submit} disabled={saving} style={btnPrimary}>{saving ? '…' : 'Oluştur'}</button>
      </div>
    </Overlay>
  );
}

export function Overlay({ children, onClose, width = 620 }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: T.panel, border: `1px solid ${T.border2}`, borderRadius: 14, padding: 24, width, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
        {children}
      </div>
    </div>
  );
}
export const Field = ({ label, children }) => (
  <div style={{ marginBottom: 12 }}>
    <div style={{ fontSize: 11, color: T.muted, marginBottom: 4 }}>{label}</div>
    {children}
  </div>
);
const inp = { width: '100%', padding: '8px 10px', background: T.card, border: `1px solid ${T.border2}`, borderRadius: 6, color: T.text, fontSize: 13, outline: 'none' };
const btnPrimary = { padding: '9px 18px', background: T.blueDark, color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 };
const btnGhost = { padding: '9px 18px', background: 'transparent', color: T.muted, border: `1px solid ${T.border2}`, borderRadius: 8, cursor: 'pointer', fontSize: 13 };
